import { nameserversToDnsProviders } from '../consts';
export const getIllegalDnsProvider = (nameservers) => {
    const illegalNameserver = nameservers?.find((ns) => !ns.isMxSupported)?.name;
    if (illegalNameserver) {
        return (nameserversToDnsProviders.find((it) => illegalNameserver.includes(it.nameserver))
            ?.dnsProvider || illegalNameserver);
    }
    return null;
};
